/** Device-local idle preference only; Firebase remains the authentication authority. */
const PREFIX = 'datacrate-keep-signed-in-v1:';
const CHANGED = 'datacrate-keep-signed-in-changed';

export function keepSignedInOnDevice(uid: string | null | undefined): boolean {
  if (!uid) return false;
  try { return window.localStorage.getItem(PREFIX + uid) === 'true'; }
  catch { return false; }
}

/** Throws when storage cannot retain the choice, so the UI never reports a false success. */
export function setKeepSignedInOnDevice(uid: string, enabled: boolean): void {
  if (!uid) throw new Error('Sign in before changing this device setting.');
  const storage = window.localStorage;
  if (enabled) storage.setItem(PREFIX + uid, 'true');
  else storage.removeItem(PREFIX + uid);
  if (keepSignedInOnDevice(uid) !== enabled) throw new Error('This browser could not save the sign-in preference.');
  window.dispatchEvent(new CustomEvent(CHANGED, { detail: uid }));
}

/** Synchronize this tab and other tabs without sharing tokens or account preferences. */
export function subscribeKeepSignedInOnDevice(uid: string | null | undefined, changed: () => void): () => void {
  if (!uid || typeof window === 'undefined') return () => {};
  const onLocalChange = (event: Event) => {
    if ((event as CustomEvent<unknown>).detail === uid) changed();
  };
  const onStorage = (event: StorageEvent) => {
    try {
      if (event.storageArea === window.localStorage && (event.key === null || event.key === PREFIX + uid)) changed();
    } catch { changed(); }
  };
  window.addEventListener(CHANGED, onLocalChange);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(CHANGED, onLocalChange);
    window.removeEventListener('storage', onStorage);
  };
}
